
export default () => ({
	filters: window.filters,
	delay: 300,
	active: false,
	results: 0,
	init() {
		let filtersChanged
		if (!this.filters) return
		this.filters.forEach( f => {
			f.options.forEach( o => {
				if( window.location.hash == `#${f.handle}=${o.slug}` ) {
					f.selected = o
					history.pushState( {}, '', location.pathname );
				}
			} )
		})

		this.$nextTick(() => {
			filtersChanged = _throttle(() => {

				this.$el.querySelectorAll('.partial--listing-article').forEach( article =>{
					let match = true

					filters.forEach( f => {
						match &= !f.selected || f.selected.slug == article.dataset[f.handle]
					})

					if( match ){
						++this.results
						article.classList.toggle( 'filtered-indent', this.results % 6 == 4 )
					}

					article.hidden = !match
				} )

				this.$refs.noResults.hidden = this.results

				setTimeout(()=>{
					this.$el.classList.remove('filters--changing')
					this.$el.classList.toggle('filters--active', this.active)
				}, 40)
			}, this.delay, { leading: false })
		})
		window.Alpine.effect(() => {
			this.active = this.filters.filter(f => f.selected).length > 0
			this.$el.classList.add( 'filters--changing' )
			this.$nextTick(() => filtersChanged() )
		})
	}
});
